import { LookupDTO } from "./lookup.model";

export class StableOrganisationDTO{
  public ID : number;
  public Address : string;
  public StreetNumber : string;
  public PostalCode : string;
  public City : string;
  public Province : string;
  public Nation : LookupDTO;
  public FK_Customer : number;
  public FK_Company : number;  
  //Francia
  public FR_NIC :string;
  public FR_ComplementAddress :string
  public FR_CountrySubentity  :string;
  
}
